
import React from "react";
import { Loader2 } from "lucide-react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";

type UserRole = 'admin' | 'user' | 'atc' | 'dm' | 'sales_assistant';

interface Role {
  role: UserRole;
}

interface RoleSelectorProps {
  availableRoles: Role[];
  selectedRole: UserRole | '';
  onRoleChange: (role: UserRole) => void;
  onSavePermissions: () => void;
  saving: boolean;
}

export const RoleSelector = ({
  availableRoles,
  selectedRole,
  onRoleChange,
  onSavePermissions,
  saving
}: RoleSelectorProps) => {
  return (
    <div className="flex items-center space-x-4">
      <Select 
        value={selectedRole} 
        onValueChange={(value) => onRoleChange(value as UserRole)}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Select a role" />
        </SelectTrigger>
        <SelectContent>
          {availableRoles.map((role) => (
            <SelectItem key={role.role} value={role.role}>
              {role.role.charAt(0).toUpperCase() + role.role.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      <Button 
        onClick={onSavePermissions} 
        disabled={saving || !selectedRole}
        className="ml-auto"
      >
        {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Save Permissions
      </Button>
    </div>
  );
};
